export default "<ng-content select=\"tc-dropdown-button\"></ng-content>\r\n<ng-content select=\"tc-dropdown-content\"></ng-content>"